import React, { useEffect, useState } from "react";
import { Bot, Mail, FileText, Share2, UserPlus, CreditCard, ShoppingCart, MessageSquare } from "lucide-react";
import api from "../../lib/api";

const KPIS = [
  ["chat_sessions", "Chat Conversations", Bot],
  ["chat_messages", "Chat Messages", MessageSquare],
  ["emails_sent", "Emails Sent", Mail],
  ["signups_30d", "Signups (30d)", UserPlus],
  ["paid_users", "Paid Customers", CreditCard],
  ["abandoned_checkouts", "Open Checkouts", ShoppingCart],
  ["blog_published", "Published Articles", FileText],
  ["social_posts", "Social Batches", Share2],
];

const AUTOMATIONS = [
  ["Max · AI Sales Chat", "Live on landing, pricing and blog pages. Answers questions, handles objections, pushes to signup/checkout."],
  ["Welcome Email", "Sent instantly on every new registration (email or Google)."],
  ["25% Unlock Nudge", "Sent once when a free trainee finishes a quarter of all lessons."],
  ["Abandoned Checkout Recovery", "Hourly cron emails anyone who started Stripe checkout 1h–3d ago and never paid."],
  ["Certificate Delivery", "Sent the moment all 8 quizzes are passed and the credential is issued."],
];

export default function OverviewTab() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/marketing/overview").then((r) => setD(r.data));
  }, []);

  return (
    <div data-testid="marketing-overview">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {KPIS.map(([k, label, Icon]) => (
          <div key={k} data-testid={`mkt-kpi-${k}`} className="border border-slate-200 rounded-sm p-5 bg-white">
            <div className="flex items-center justify-between">
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">{label}</div>
              <Icon className="w-4 h-4 text-orange-600" />
            </div>
            <div className="font-display font-black text-3xl tracking-tighter mt-3 text-slate-950">{d ? d[k] : "—"}</div>
          </div>
        ))}
      </div>
      <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 mt-10">Running automations</h2>
      <div className="mt-3 border border-slate-200 rounded-sm divide-y divide-slate-200">
        {AUTOMATIONS.map(([t, desc]) => (
          <div key={t} className="p-4 flex items-start gap-4">
            <span className="mt-1.5 w-2 h-2 rounded-full bg-green-500 shrink-0" />
            <div>
              <div className="font-semibold text-slate-900">{t}</div>
              <div className="text-sm text-slate-600">{desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
